import React, { Fragment, useState } from "react";
import { Auth } from "aws-amplify";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Listbox, Transition } from "@headlessui/react";
import { TbInfoSquareRoundedFilled } from "react-icons/tb";
import { AiOutlineCheck } from "react-icons/ai";
import { HiChevronUpDown } from "react-icons/hi2";
import flagIndia from "../Assets/flag-india.png";
import flagUs from "../Assets/Flag-Us.png";
import { CreateUSER } from "../Components/API/UserinfoAPI";

const people = [
  {
    id: 1,
    name: "India",
    avatar: flagIndia,
  },
  {
    id: 2,
    name: "United States",
    avatar: flagUs,
  },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const SignUp = () => {
  const navigate = useNavigate();
  const [selected, setSelected] = useState(people[1]);
  const [otpconfirm, setOtpconfirm] = useState(false);
  const [clientId, setClientId] = useState();
  const [userId, setUserId] = useState();
  const [signupData, setSignUpData] = useState({
    email: "",
    firstname: "",
    password: "",
    phone_number: "",
    authenticationCode: "",
  });
  const [validEmail, setvalidEmail] = useState("");
  const [validFirstname, setvalidFirstname] = useState("");
  const [validPassword, setvalidPassword] = useState("");
  const [validAuthenticationCode, setvalidAuthenticationCode] = useState("");
  const [validPhone, setvalidPhone] = useState("");
  let username;

  const handleChange = (e) => {
    setSignUpData({
      ...signupData,
      [e.target.name]: e.target.value,
      county_name: selected.name,
    });
  };

  let hashStateData = (string) => {
    let hash = 0;

    if (string.length === 0) return hash;

    for (let i = 0; i < string.length; i++) {
      let char = string.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash;
    }
    return setClientId(hash);
  }

  const handleSignUp = async () => {
    const { email, firstname, county_name, password, phone_number } = signupData;
    hashStateData(email.slice(email.indexOf('@') + 1))
    username = email;
    try {
      if (!validation()) {
        let signUpInfor = await Auth.signUp({
          username,
          county_name,
          password,
          firstname,
          phone_number,
          attributes: { email },
        });
        setUserId(signUpInfor.userSub)
        toast.success("OTP send successfully", { autoClose: 5000 });
        setOtpconfirm(true);
      }
    } catch (error) {
      toast.error(error.message, { autoClose: 5000 });
    }
  };

  const verifySignUp = async () => {
    const { firstname, authenticationCode, email, county_name } = signupData;
    username = email;
    const postParams = {
      createUSERInput: {
        client_id: clientId,
        user_id: userId,
        country: county_name,
        email: email,
        first_name: firstname,
        inserted_dt: new Date().toISOString()
      },
    };

    try {
      if (authenticationCode === "") {
        setvalidAuthenticationCode("Authentication Code is required");
      } else {
        await Auth.confirmSignUp(username, authenticationCode);
        await CreateUSER(postParams);
        toast.success("Sign up successfully", { autoClose: 5000 });
        navigate("/signIn");
      }
    } catch (error) {
      toast.error(error.message, { autoClose: 5000 });
    }
  };

  const resendConfirmationCode = async () => {
    try {
      await Auth.resendSignUp(signupData.email);
      toast.success("code resent successfully", { autoClose: 5000 });
    } catch (err) {
      toast.error(err.message, { autoClose: 5000 });
    }
  };

  const isValidEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  const validation = () => {
    const { email, firstname, password, phone_number } = signupData;
    let valid = false;
    if (email === "") {
      setvalidEmail("Email is required");
      valid = true;
    }
    if (password === "") {
      setvalidPassword("Password is required");
      valid = true;
    }
    if (firstname === "") {
      setvalidFirstname("Firstname is required");
      valid = true;
    }
    if (phone_number === "") {
      setvalidPhone("phone number is required");
      valid = true;
    }
    return valid;
  };

  return (
    <div>
      <div className="h-screen w-full flex justify-center items-center p-[20px]">
        <div className="max-w-[500px] rounded-lg w-full shadow-lg bg-white sm:p-[50px] p-[20px]">
          <h3 className="text-gray-700 font-semibold sm:text-[20px] text-[18px]">
            {otpconfirm === false
              ? "Create your account"
              : "Check your mail and Enter OTP"}
          </h3>
          <div className="mt-5">
            {otpconfirm === false && (
              <>
                <div className="flex flex-col gap-2">
                  <label className="font-medium text-sm text-gray-700">
                    Email
                  </label>
                  <input
                    name="email"
                    onChange={(e) => handleChange(e)}
                    type="text"
                    className="border-[1px] border-gray-300 focus:outline-none text-gray-600 px-[10px] py-[7px] rounded-md"
                  />
                  <p className="text-red-600">
                    {signupData.email === "" ? validEmail : ""}
                    {signupData.email !== "" && !isValidEmail(signupData.email)
                      ? "Email is incorrect"
                      : ""}
                  </p>
                </div>
                <div className="flex flex-col gap-2 mt-7">
                  <label className="font-medium text-sm text-gray-700">
                    Full name
                  </label>
                  <input
                    name="firstname"
                    onChange={(e) => handleChange(e)}
                    type="text"
                    className="border-[1px] border-gray-300 focus:outline-none text-gray-600 px-[10px] py-[7px] rounded-md"
                  />
                  <p className="text-red-600">
                    {signupData.firstname === "" ? validFirstname : ""}
                  </p>
                </div>
                <div className="flex flex-col gap-2 mt-7">
                  <label className="font-medium text-sm text-gray-700">
                    Phone Number
                  </label>
                  <input
                    onChange={(e) => handleChange(e)}
                    name="phone_number"
                    type="number"
                    className="border-[1px] border-gray-300 focus:outline-none text-gray-600 px-[10px] py-[7px] rounded-md"
                  />
                  <p className="text-red-600">
                    {signupData.phone_number === ""
                      ? validPhone
                      : signupData.phone_number.length < 10 ||
                        signupData.phone_number.length > 10
                        ? "Phone number should be 10 digits"
                        : ""}
                  </p>
                </div>
                <div className="flex flex-col gap-2 mt-7">
                  <label className="font-medium text-sm text-gray-700 flex items-center gap-1">
                    Country
                    <TbInfoSquareRoundedFilled className="text-[#5851ff]" />
                  </label>
                  <Listbox
                    value={selected}
                    name="county_name"
                    onChange={setSelected}
                  >
                    {({ open }) => (
                      <>
                        <div className="relative">
                          <Listbox.Button className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 sm:text-sm sm:leading-6">
                            <span className="flex items-center">
                              <img
                                src={selected.avatar}
                                alt=""
                                className="h-5 w-7 flex-shrink-0 rounded-[3px]"
                              />
                              <span className="ml-3 block truncate">
                                {selected.name}
                              </span>
                            </span>
                            <span className="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2">
                              <HiChevronUpDown
                                className="h-5 w-5 text-gray-400"
                                aria-hidden="true"
                              />
                            </span>
                          </Listbox.Button>

                          <Transition
                            show={open}
                            as={Fragment}
                            leave="transition ease-in duration-100"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                          >
                            <Listbox.Options className="absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                              {people.map((person) => (
                                <Listbox.Option
                                  key={person.id}
                                  className={({ active }) =>
                                    classNames(
                                      active
                                        ? "bg-indigo-600 text-white"
                                        : "text-gray-900",
                                      "relative cursor-default select-none py-2 pl-3 pr-9"
                                    )
                                  }
                                  value={person}
                                >
                                  {({ selected, active }) => (
                                    <>
                                      <div className="flex items-center">
                                        <img
                                          src={person.avatar}
                                          alt=""
                                          className="h-5 w-7 flex-shrink-0 rounded-[3px]"
                                        />
                                        <span
                                          className={classNames(
                                            selected
                                              ? "font-semibold"
                                              : "font-normal",
                                            "ml-3 block truncate"
                                          )}
                                        >
                                          {person.name}
                                        </span>
                                      </div>

                                      {selected ? (
                                        <span
                                          className={classNames(
                                            active
                                              ? "text-white"
                                              : "text-indigo-600",
                                            "absolute inset-y-0 right-0 flex items-center pr-4"
                                          )}
                                        >
                                          <AiOutlineCheck
                                            className="h-5 w-5"
                                            aria-hidden="true"
                                          />
                                        </span>
                                      ) : null}
                                    </>
                                  )}
                                </Listbox.Option>
                              ))}
                            </Listbox.Options>
                          </Transition>
                        </div>
                      </>
                    )}
                  </Listbox>
                </div>
                <div className="flex flex-col gap-2 mt-7">
                  <label className="font-medium text-sm text-gray-700">
                    Password
                  </label>
                  <input
                    onChange={(e) => handleChange(e)}
                    name="password"
                    type="password"
                    className="border-[1px] border-gray-300 focus:outline-none text-gray-600 px-[10px] py-[7px] rounded-md"
                  />
                  <p className="text-red-600">
                    {signupData.password === "" ? validPassword : ""}
                  </p>
                </div>
              </>
            )}
            {otpconfirm === true && (
              <div className="flex flex-col gap-2">
                <label className="font-medium text-sm text-gray-700">OTP</label>
                <input
                  onChange={(e) => handleChange(e)}
                  name="authenticationCode"
                  type="text"
                  className="border-[1px] border-gray-300 focus:outline-none text-gray-600 px-[10px] py-[7px] rounded-md"
                />
                <p className="text-red-600">
                  {signupData.authenticationCode === ""
                    ? validAuthenticationCode
                    : ""}
                </p>
              </div>
            )}
          </div>
          {otpconfirm === false && (
            <div className="my-7">
              <button
                onClick={handleSignUp}
                className="text-center px-3 sm:py-3 py-2 rounded-md bg-[#9c99ed] w-full text-sm font-medium text-white"
              >
                Create account
              </button>
            </div>
          )}
          {otpconfirm === true && (
            <div className="my-7">
              <button
                onClick={() => verifySignUp()}
                className="text-center px-3 sm:py-3 py-2 rounded-md bg-[#9c99ed] w-full text-sm font-medium text-white"
              >
                Verify
              </button>
            </div>
          )}
          <div className="flex justify-center items-center gap-1">
            {otpconfirm === true && (
              <>
                <button
                  onClick={() => resendConfirmationCode()}
                  className="font-medium text-sm text-gray-700"
                >
                  re-send otp
                </button>
                <br />
              </>
            )}
            <button className="font-medium text-sm text-gray-700">
              Have an account?
            </button>
            <button
              className="font-medium text-sm text-[#5851ff] cursor-pointer"
              onClick={() => navigate("/signIn")}
            >
              Sign In
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
